 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780310096153_COVER from '@/components/text/9780310096153_Cover'
 import TEXT9780310096153_ALSO_BY from '@/components/text/9780310096153_Also_by'
 import TEXT9780310096153_TITLE from '@/components/text/9780310096153_Title'
 import TEXT9780310096153_COPYRIGHT from '@/components/text/9780310096153_Copyright'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780310096153_THE_CHARACTERS from '@/components/text/9780310096153_The_Characters'
 import TEXT9780310096153_FROM_THE_FALL_OF_LUCIFER from '@/components/text/9780310096153_From_The_Fall_of_Lucifer'
 import TEXT9780310096153_CHAPTER1 from '@/components/text/9780310096153_Chapter1'
 import TEXT9780310096153_CHAPTER2 from '@/components/text/9780310096153_Chapter2'
 import TEXT9780310096153_CHAPTER3 from '@/components/text/9780310096153_Chapter3'
 import TEXT9780310096153_CHAPTER4 from '@/components/text/9780310096153_Chapter4'
 import TEXT9780310096153_CHAPTER5 from '@/components/text/9780310096153_Chapter5'
 import TEXT9780310096153_CHAPTER6 from '@/components/text/9780310096153_Chapter6'
 import TEXT9780310096153_CHAPTER7 from '@/components/text/9780310096153_Chapter7'
 import TEXT9780310096153_CHAPTER8 from '@/components/text/9780310096153_Chapter8'
 import TEXT9780310096153_CHAPTER9 from '@/components/text/9780310096153_Chapter9'
 import TEXT9780310096153_CHAPTER10 from '@/components/text/9780310096153_Chapter10'
 import TEXT9780310096153_CHAPTER11 from '@/components/text/9780310096153_Chapter11'
 import TEXT9780310096153_CHAPTER12 from '@/components/text/9780310096153_Chapter12'
 import TEXT9780310096153_CHAPTER13 from '@/components/text/9780310096153_Chapter13'
 import TEXT9780310096153_CHAPTER14 from '@/components/text/9780310096153_Chapter14'
 import TEXT9780310096153_CHAPTER15 from '@/components/text/9780310096153_Chapter15'
 import TEXT9780310096153_CHAPTER16 from '@/components/text/9780310096153_Chapter16'
 import TEXT9780310096153_CHAPTER17 from '@/components/text/9780310096153_Chapter17'
 import TEXT9780310096153_CHAPTER18 from '@/components/text/9780310096153_Chapter18'
 import TEXT9780310096153_CHAPTER19 from '@/components/text/9780310096153_Chapter19'
 import TEXT9780310096153_CHAPTER20 from '@/components/text/9780310096153_Chapter20'
 import TEXT9780310096153_CHAPTER21 from '@/components/text/9780310096153_Chapter21'
 import TEXT9780310096153_CHAPTER22 from '@/components/text/9780310096153_Chapter22'
 import TEXT9780310096153_CHAPTER23 from '@/components/text/9780310096153_Chapter23'
 import TEXT9780310096153_CHAPTER24 from '@/components/text/9780310096153_Chapter24'
 import TEXT9780310096153_CHAPTER25 from '@/components/text/9780310096153_Chapter25'
 import TEXT9780310096153_CHAPTER26 from '@/components/text/9780310096153_Chapter26'
 import TEXT9780310096153_CHAPTER27 from '@/components/text/9780310096153_Chapter27'
 import TEXT9780310096153_CHAPTER28 from '@/components/text/9780310096153_Chapter28'
 import TEXT9780310096153_CHAPTER29 from '@/components/text/9780310096153_Chapter29'
 import TEXT9780310096153_CHAPTER30 from '@/components/text/9780310096153_Chapter30'
 import TEXT9780310096153_CHAPTER31 from '@/components/text/9780310096153_Chapter31'
 import TEXT9780310096153_CHAPTER32 from '@/components/text/9780310096153_Chapter32'
 import TEXT9780310096153_CHAPTER33 from '@/components/text/9780310096153_Chapter33'
 import TEXT9780310096153_CHAPTER34 from '@/components/text/9780310096153_Chapter34'
 import TEXT9780310096153_CHAPTER35 from '@/components/text/9780310096153_Chapter35'
 import TEXT9780310096153_CHAPTER36 from '@/components/text/9780310096153_Chapter36'
 import TEXT9780310096153_CHAPTER37 from '@/components/text/9780310096153_Chapter37'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXT9780310096153_EXTRACT from '@/components/text/9780310096153_Extract'
 import TEXT9780310096153_PROLOGUE from '@/components/text/9780310096153_Prologue'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780310096153_The_Characters",
 			"name" : "text/9780310096153_The_Characters",
 			"component" : TEXT9780310096153_THE_CHARACTERS
 		},
 		{
 			"path" : "/text/9780310096153_From_The_Fall_of_Lucifer",
 			"name" : "text/9780310096153_From_The_Fall_of_Lucifer",
 			"component" : TEXT9780310096153_FROM_THE_FALL_OF_LUCIFER
 		},
 		{
 			"path" : "/text/9780310096153_Chapter1",
 			"name" : "text/9780310096153_Chapter1",
 			"component" : TEXT9780310096153_CHAPTER1
 		},
 		{
 			"path" : "/text/9780310096153_Chapter2",
 			"name" : "text/9780310096153_Chapter2",
 			"component" : TEXT9780310096153_CHAPTER2
 		},
 		{
 			"path" : "/text/9780310096153_Chapter3",
 			"name" : "text/9780310096153_Chapter3",
 			"component" : TEXT9780310096153_CHAPTER3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js